<template>
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span>{{ $t('menu.systems') }}</h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.systems') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_system" @click.prevent="addSystem">{{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="System"
            fileName="System"
            modelName="system"
            deleteURL="todos/v1/delete_system/"
            :editorPatchURL="editorPatchURL"
            :columns="columns"
            :objects="systemList"
            :exportColumns="[0, 1]"
            :extraActions="extraActions"
            :editorCallback="true"
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showSystem"
            @callDrawback="drawCallbackFunctions"
            @editorUpdated="setSystem"
            v-if="promiseFinished"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </diV>

    <!--modal section starts here-->
    <system :currentSystem="currentSystem" :departments="departments" @systemUpdated="setSystem">
      <template v-slot:fileUpload><fileUpload :commentObject="currentSystem" modelName="system" @attachmentUpdated="setSystem" modelVerboseName="System"></fileUpload></template>
      <template v-slot:comments><comments :commentObject="currentSystem" modelName="system" @commentUpdated="setSystem" modelVerboseName="System"></comments></template>
    </system>

    <task :currentTodo="currentTodo" origin="system">
      <template v-slot:steps>
        <Steps
          :totalSteps="currentTodo.steps"
          :taskID="currentTodo.id"
          @stepsUpdated="setSteps"
        ></Steps>
      </template>
    </task>

    <DKLVendor :supplier="currentSupplier">
      <template v-slot:fileUpload><FileUploadComponent :commentObject="currentSupplier" modelName="supplier" modelVerboseName="Dienstleister"></FileUploadComponent></template>
      <template v-slot:comments><CommentComponent :commentObject="currentSupplier" modelName="supplier" @commentUpdated="updateSupplierForComment" modelVerboseName="Dienstleister"></CommentComponent></template>
    </DKLVendor><!-- modal -->

  </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
  import service from '@/utils/request.js';
  import {deepCopy} from '@/utils/index.js';
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import system from "@/components/component/SystemComponent.vue";
  import {newTodo, objectModalName, newSystem, newSupplier} from "@/utils/enums";
  import Steps from "@/components/component/Steps.vue";
  import task from "@/components/component/TodoComponent.vue";
  import comments from "@/components/component/CommentComponent.vue";
  import fileUpload from "@/components/component/FileUploadComponent.vue";
import DKLVendor from "@/components/component/VendorComponent.vue";
import CommentComponent from "@/components/component/CommentComponent.vue";
import FileUploadComponent from "@/components/component/FileUploadComponent.vue";
import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";

  export default {
    components: {
      FingerPrintSpinner,
      DisplayColumnsComponent,
      FileUploadComponent,
      CommentComponent,
      DKLVendor,
      task, Steps, system, DataTableDSMS, comments, fileUpload},
    data() {
      return {
        systemList: [],
        currentSystem: {},
        currentSupplier: newSupplier,
        table: null,
        editor: null,
        promiseFinished: false,
        editorPatchURL: '/todos/v1/patch_system/',
        currentTodo: {},
      }
    },
    async created() {
      await this.getSystems()
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, user: state => state.user, account: state => state.account, departments: state => state.account.departments, suppliers: state => state.account.suppliers}),
      ...mapGetters(['selectDepartmentOptions', 'selectSupplierOptions']),

      columns() {
        const that = this
        return [
        {
          label: 'Nr.#',
          name: 'sequence',
          enableEditor: false,
          definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
        },
        {
          label: this.$t('name'),
          name: 'name',
          type: 'text',
          enableEditor: true,
          definition: { data: "name" },
        },
        {
          label: this.$t('department'),
          name: 'department',
          type: 'select2',
          options: this.selectDepartmentOptions,
          enableEditor: true,
          definition: { data: "department" },
        },
        {
          label: this.$t('purpose_data_processing'),
          name: 'purpose',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "purpose" },
        },
        {
          label: this.$t('storage_place'),
          name: 'storage_place',
          type: 'text',
          enableEditor: true,
          definition: { data: "storage_place" },
        },
        {
          label: this.$t('other_responsible'),
          name: 'other_responsible',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "other_responsible" },
        },
        {
          label: this.$t('supplier'),
          name: 'supplier',
          type: 'select2',
          options: this.selectDepartmentOptions,
          enableEditor: true,
          definition: { data: "supplier", render: (data) => data == null ? 'intern' : `<a href="#" class="related-supplier mr-3" data-supplier-name="${data}">${data}</a><a href="#" class="edit-table-field"><i class="fa fa-pencil"></i></a>` },
        },
        {
          label: this.$t('toms'),
          name: 'toms',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "toms" },
        },
        {
          label: this.$t('authentication'),
          name: 'authentication',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "authentication" },
        },
        {
          label: this.$t('deletion'),
          name: 'deletion',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "deletion" },
        },
        {
          label: this.$t('backup'),
          name: 'backup',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "backup" },
        },
        {
          label: this.$t('menu.system_assessment'),
          name: 'system_assessment',
          enableEditor: false,
          definition: { data: "system_assessment", render: (data) => data === 'released' ? that.$t('released') : (data === 'processing' ? that.$t('processing') : that.$t('na'))},
        },
        {
          label: this.$t('modified'),
          name: 'remarks',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "remarks" },
        },
        {
          label: this.$t('modified'),
          name: 'modified',
          type: 'text',
          enableEditor: false,
          definition: { data: "modified", render: (data) => typeof data === 'string' ? data.substring(0, 10) : '' },
        },
      ]},
    },
    mounted() {
    },
    updated ()
    {

      // Date Time Picker

      if ($('.datetimepicker').length > 0) {
        $('.datetimepicker').datetimepicker({
          format: 'DD/MM/YYYY',
          icons: {
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            next: 'fa fa-angle-right',
            previous: 'fa fa-angle-left'
          }
        });
      }
    },
    methods: {
      ...mapMutations({setEdit: 'SET_EDIT'}),
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
        this.editor.field('department').update(this.selectDepartmentOptions)
        this.editor.field('supplier').update(this.selectSupplierOptions)
      },
      setSteps(steps) {
        this.currentTodo.steps = steps
      },
      updateSupplierForComment(supplierObject) {
        const objectIndex = this.supplierList.findIndex(item => item.id === supplierObject.id)
        this.supplierList[objectIndex] = supplierObject
      },
      extraActions(data) {
        return `<a class="dropdown-item related-task" href="#" data-system-id="${data.id}">Verbundene Maßnahme</a><a class="dropdown-item add-task" href="#" data-system-id="${data.id}">Maßnahme erstellen</a>`
      },
      drawCallbackFunctions() {
        const that = this
        $('.related-task').off('click').on('click', function(e) {
          e.preventDefault();
          let systemID = $(e.target).data('system-id');
          that.gotoTasks(systemID)
        })
        $('.add-task').off('click').on('click', function(e) {
          e.preventDefault();
          const systemID = $(e.target).data('system-id');
          that.addTodo(systemID)
        })
        $('.related-supplier').off('click').on('click', function(e) {
          e.preventDefault();
          const targetA = $(e.target).closest('a')
          const supplierName = targetA.data('supplier-name');
          const supplierID = that.suppliers.filter(supplier => supplier.text === supplierName)[0].value
          service.request({
            url: `todos/v1/get_supplier/${supplierID}`,
            method: 'GET',
            responseType: 'json'
          }).then((response) => {
            that.currentSupplier = response.data;
            $('#' + objectModalName.supplier).modal('show')
          }).catch(function(err) {
            console.log(err)
          })
        })
      },
      addTodo(systemID) {
        this.currentTodo = deepCopy(newTodo)
        this.setEdit(true)
        this.currentTodo.object_id = systemID
        this.currentTodo.model = 'system'
        this.currentSystem = this.systemList.filter(item => item.id === systemID)[0]
        $('#' + objectModalName.task).modal('show');
      },
      gotoTasks(systemID) {
        this.$router.push({name: 'massnahmenplan', params: {questionID: systemID, questionDescription: systemID.toString(), model: 'system'}})
      },
      addSystem() {
        this.currentSystem = deepCopy(newSystem)
        this.currentSystem.customer = this.account.name
        this.showSystem(null)
      },
      showSystem(systemID) {
        if (systemID != null) this.currentSystem = this.systemList.filter(item => item.id === systemID)[0]
        $('#' + objectModalName.system).modal('show')
      },
      async setSystem(systemObject) {
        const systemIndex = this.systemList.findIndex(item => item.id === systemObject.id)
        if (systemIndex === -1) {
          this.systemList = this.systemList.map(item => {
            item.sequence = item.sequence + 1
            return item
          })
          this.systemList.push(systemObject)
        } else {
          this.systemList[systemIndex] = systemObject
        }
        this.table.clear().rows.add(this.systemList).draw(false)
      },
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      async getSystems() {
        const that = this
        service.request({
          url: `todos/v1/system/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.systemList = response.data;
          that.promiseFinished = true
        }).catch(function(err) {
          console.log(err)
          that.promiseFinished = true
        })
      },
    }
  }
</script>
